import type { IContextMutationResult } from '@modules/core/services/query/types';
import type { IDownloadReportLinkResponse } from '@modules/download-report/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import {
  DOWNLOAD_REPORT_PERMISSIONS,
} from '@modules/download-report/constants';
import { IMPORTED_DATA_MUTATION_API_URL, IMPORTED_DATA_MUTATION_KEY } from '@modules/imported-data/constants';
import { useToastStore } from '@modules/toast/store';

export default function useDownloadImportedDataMutation(): IContextMutationResult<
  IDownloadReportLinkResponse,
  Error,
  number
> {
  const { fetchGet } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<IDownloadReportLinkResponse, Error, number>({
    mutationKey: [IMPORTED_DATA_MUTATION_KEY],
    mutationFn: (id) => fetchGet<IDownloadReportLinkResponse>(
      IMPORTED_DATA_MUTATION_API_URL,
      {
        permission: DOWNLOAD_REPORT_PERMISSIONS.SHOW,
        urlParams: {
          id,
        },
      },
    ),
    onSuccess() {
      displayPresetToast('success');
    },
  });
}
